import Utils from '../../framework/utils.js';
import DataEvent from '../../framework/data-event.js';
import TomSelect from 'tom-select';

// FilterView
// ==========
//
// Manages the display of the filter form

class FilterView extends EventTarget {
  // `new FilterView(tmpl, model)`
  //
  // Populates the form template with data from the model, and establishes
  // all necessary event transactions.

  constructor(tmpl, model) {
    super();
    Utils.bindMethods(this, ['onModelChange', 'onFieldChange', 'onSubmitClick', 'onResetClick']);

    this.dom = tmpl;
    model.addEventListener('Model.Change', this.onModelChange);
    this.initialRender(model);

    this.dom.querySelectorAll('input').forEach((field) => {
      field.addEventListener('change', this.onFieldChange);
    })
    this.dom.querySelector('.careers-table_filter-form_submit').addEventListener('click', this.onSubmitClick);
    this.dom.querySelector('.careers-table_filter-form_reset').addEventListener('click', this.onResetClick);
  }

  // `initialRender(model)`
  //
  // Expected to only run once, this populates the filter values from the provided model

  initialRender(model) {
    model.get('options.all.locations').forEach((item) => {
      this.dom.querySelector('.careers-table_filter-form_location').insertAdjacentHTML('beforeend', `<option value="${ item.get('id') }">${ item.getLabel() }</option>`)
    })
    model.get('options.all.employeeType').forEach((item) => {
      this.dom.querySelector('.careers-table_filter-form_employeeType').insertAdjacentHTML('beforeend', `<option value="${item}">${item}</option>`)
    })
    model.get('options.all.department').forEach((item) => {
      this.dom.querySelector('.careers-table_filter-form_department').insertAdjacentHTML('beforeend', `<option value="${item}">${item}</option>`)
    })
    model.get('options.all.brand').forEach((item) => {
      this.dom.querySelector('.careers-table_filter-form_brand').insertAdjacentHTML('beforeend', `<option value="${item}">${item}</option>`)
    })

    this._selects = {};
    this.dom.querySelectorAll('select').forEach((elem) => {
      let key = elem.getAttribute('data-wf-id');
      this._selects[key] = (new TomSelect(elem, {
        items: model.get(`selectedFilter.${key}`).map((item) => key == 'location' ? item.get('id') : item),
        hidePlaceholder: true,
        plugins: {
          remove_button: {},
          no_backspace_delete: {}
        }
      }));
      this._selects[elem.getAttribute('data-wf-id')].on('change', this.onFieldChange);
    });

    this.render(model);
  }

  // `render(model)`
  //
  // Updates the form field display based on the given model

  render(model) {
    this.dom.querySelector('.careers-table_filter-form_keyword').value = model.get('selectedFilter.keyword');

    Object.entries(this._selects).forEach(([key, select]) => {
      // Set filters to selected values
      select.setValue(model.get(`selectedFilter.${key}`) ? model.get(`selectedFilter.${key}`).map((item) => key == 'location' ? item.get('id') : item) : [], true)

      // limit options to only displayed
      select.clearOptions();
      select.addOptions(model.get(`options.displayed.${key}${key == 'location' ? 's' : ''}`).map((item) => {
        return {
          value: key == 'location' ? item.get('id') : item,
          text: key == 'location' ? item.getLabel() : item
        };
      }))
      select.refreshOptions(false);
    })
  }

  // `onModelChange()`
  //
  // Re-renders the form display whenever the underlying model state changes

  onModelChange(evt) {
    this.render(evt.currentTarget);
  }

  // `onFieldChange()`
  //
  // Fires a change event with the aggregate form values whenever one of the field values changes.
  
  onFieldChange(evt) {
    this.dispatchEvent(new DataEvent(FilterView.Events.CHANGE, {
      keyword: this.dom.querySelector('.careers-table_filter-form_keyword').value,
      location: this._selects.location.getValue(),
      employeeType: this._selects.employeeType.getValue(),
      department: this._selects.department.getValue(),
      brand: this._selects.brand.getValue(),
    }))
  }
  
  onSubmitClick(evt) {
    evt.preventDefault();
    this.dispatchEvent(new Event(FilterView.Events.SUBMIT))
    return false;
  }
  onResetClick(evt) {
    evt.preventDefault();
    this.dispatchEvent(new Event(FilterView.Events.RESET));
    return false;
  }
}

FilterView.Events = {
  CHANGE: 'FilterView.Change',
  RESET: 'FilterView.Reset',
  SUBMIT: 'FilterView.Submit'
}

export default FilterView;